module.exports = __webpack_public_path__ + "img/lang_b.0345a89d.svg";